import { useNavigate, useOutletContext } from 'react-router-dom'

import { ProfileIndexPageDocument } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import ContractVersionsPage from 'modules/contracts/pages/ContractVersionsPage'

const IndexPage = () => {
  const { navigation } = useNavigation()

  const { employeeId } = useOutletContext<{
    employeeId: number
  }>()

  const navigate = useNavigate()

  const { data } = useQuery(ProfileIndexPageDocument, {
    variables: {
      employeeId,
    },
  })
  const canSeeContract = data?.employees.employee?._policies?.seeContract.can ?? false

  if (canSeeContract) {
    return <ContractVersionsPage />
  }

  navigate(navigation.profile.fullPath())

  return null
}

export default IndexPage
